import { setSiteOrigin } from './askSession.js';

const HOME_KEY = 'home_ask_return:v1';
let homeSnapshot = null;
let departure = null;

export function saveHomeAskSnapshot(snapshot) {
  homeSnapshot = snapshot;
  try {
    if (snapshot) window.sessionStorage.setItem(HOME_KEY, JSON.stringify(snapshot));
    else window.sessionStorage.removeItem(HOME_KEY);
  } catch { /* The in-memory snapshot remains available. */ }
}

export function loadHomeAskSnapshot() {
  if (homeSnapshot) return homeSnapshot;
  try {
    const value = JSON.parse(window.sessionStorage.getItem(HOME_KEY));
    if (value?.state?.askOpen && typeof value.state.askAnswer === 'string') homeSnapshot = value;
  } catch { /* A fresh session has no answer to restore. */ }
  return homeSnapshot;
}

export function prepareAskSourceReturn(origin) {
  departure = origin;
  setSiteOrigin(origin);
  window.dispatchEvent(new CustomEvent('ask-origin-change'));
}

export function consumeAskSourceDeparture() {
  const value = departure;
  departure = null;
  return value;
}
